import { connect } from "react-redux";

import { getFeature } from "@template/state/modules/features";

import SecuredTouch from "./SecuredTouch";

const mapStateToProps = state => {
  const securedTouchFeature = getFeature(state, "emf-66-web-stc-secured-touch");
  return {
    securedTouchEnabled: securedTouchFeature && securedTouchFeature.enabled
  };
};

export default connect(mapStateToProps, null)(SecuredTouch);
